module.exports = __webpack_public_path__ + "img/renzhengshibai.99f9e9b7.png";